module.exports = __webpack_public_path__ + "21_vi.jpg?e37c9aa005f3ce6fc94a23914df16565";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/21_vi.jpg
// module id = 179
// module chunks = 0